export enum PasswordValidator {
  PASSWORD_IS_MANDATORY = 'password_is_mandatory',
  PASSWORD_IS_SHORT = 'password_is_short',
  PASSWORD_IS_WEAK = 'password_is_weak',
}

function mbStrlen(str: string) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    len += str.charCodeAt(i) < 0 || str.charCodeAt(i) > 255 ? 2 : 1;
  }
  return len;
}

export function validatePassword(value: string, strength: number, length: number) {
  if (typeof value !== 'string' || String(value).trim().length === 0) {
    return {
      error: PasswordValidator.PASSWORD_IS_MANDATORY,
    };
  }

  if (mbStrlen(value) < length) {
    return {
      error: PasswordValidator.PASSWORD_IS_SHORT,
    };
  }

  const hasLowerLettersRegexp = /[a-zа-я]/g;
  const hasUpperLettersRegexp = /[A-ZА-Я]/g;
  const hasNumbersRegexp = /[0-9]/g;

  const hasLowerLetters = Number(hasLowerLettersRegexp.test(value));
  const hasUpperLetters = Number(hasUpperLettersRegexp.test(value));
  const hasNumbers = Number(hasNumbersRegexp.test(value));

  if (hasLowerLetters + hasUpperLetters + hasNumbers >= strength) {
    return null;
  }
  return {
    error: PasswordValidator.PASSWORD_IS_WEAK,
  };
}
